import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { FactuurService } from 'src/app/shared/dataservices/factuur.service';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { FactuurInfo } from 'src/app/shared/model/factuur';
//import { CoreModule } from '@angular/flex-layout';

@Component({
  selector: 'app-factuur-edit-lines',
  templateUrl: './factuur-edit-lines.component.html',
  styleUrls: ['./factuur-edit-lines.component.less']
})
export class FactuurEditLinesComponent implements OnInit {

  @Input() correctie : boolean = false;
  @Input() factuurID : number;
  factuurInkoopList : Array<FactuurInfo> = null;

  constructor(private relatiesService: RelatiesService,
    private objectenService: ObjectenService,
    private factuurService: FactuurService,
    private toastr: ToastrService
    ) { }

  ngOnInit(): void {
  }


  ngOnChanges(changes: SimpleChanges) {
    if (!this.factuurID) {
      this.factuurInkoopList = null;
      return
    }
    if (this.correctie) {
      this.factuurService.getFactuurInfoCorr(this.factuurID).subscribe(data => {
        this.factuurInkoopList =  data;
        this.ngOnInit();
      })
    } else {
      this.factuurService.getFactuurInfo(this.factuurID).subscribe(data => {
        this.factuurInkoopList =  data;
        this.ngOnInit();
      })
    }
  }


  newLine(line : FactuurInfo) {
    this.factuurInkoopList.push(line);
    this.ngOnInit();
  }


  deleted(id: any) {
    this.factuurInkoopList.forEach( (item, index) => {
      if(item.ID === id) {
        this.factuurInkoopList.splice(index,1);
      }
  });
  }

  sum() {
    let totaal =0;
    this.factuurInkoopList.forEach( e => totaal += (e.KostenEuro * 1))
    return totaal;
  }



}
